var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'retiree-list',
  created () {
    var readMore = false
    if (this.currentPage !== null && this.currentPage >= 1) {
      readMore = 'keepload'
    }
    this.shopGet()
    this.usertypeGet()

    if (this.isAppNotIncluded) {
      window.sessionStorage.removeItem('shopIds')
      window.sessionStorage.setItem('shopIds', window.localStorage.getItem("shop_id"))
    }

    var ssShopIds = window.sessionStorage.getItem("shopIds")
    var ssUserName = window.sessionStorage.getItem("userName")
    var ssUserTypeIds = window.sessionStorage.getItem("userTypeIds")

    if (ssShopIds == null || ssShopIds.length == 0) {
      if ((this.isSystemManagement || this.isAppIncluding) && (window.sessionStorage.getItem('shopNull') == 'on')) {
        this.shopIds = []
      } else {
        this.shopIds = window.localStorage.getItem("shop_id").split(",")
      }
    } else {
      this.shopIds = ssShopIds.split(",")
    }
    if (ssUserName !== null) {
      this.userName = ssUserName
    }
    if (ssUserTypeIds == null || ssUserTypeIds.length == 0) {
    } else {
      this.usertypeIds = ssUserTypeIds.split(",")
    }

    utils.backClear()

    // ソート設定
    this.loadSortState()

    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      shopName: '',
      userName: '',
      usertypeName: '',
      searchCallbackFlag: false,
      shopGetCallbackFlag: false,
      usertypeGetCallbackFlag: false,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'login_id':       {'state': false, 'order': false},
        'user_name':      {'state': false, 'order': false},
        'shop_name':      {'state': false, 'order': false},
        'age':            {'state': false, 'order': false},
        'user_type_name': {'state': false, 'order': false},
        'join_date':      {'state': false, 'order': false},
        'over_date':      {'state': true, 'order': false}
      },
      shopIds: [],
      usertypeIds: [],
      shopDisabledFlag: false,
      searchTotalCount: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    users () {
      return this.$store.getters.users
    },
    shops () {
      return this.$store.getters.shopsAll
    },
    usertypes () {
      return this.$store.getters.usertypesAll
    },
    csvData () {
      return this.$store.getters.csvDownload
    },
    csvShopsData () {
      return this.$store.getters.csvShops
    },
    csvUsertypesData () {
      return this.$store.getters.csvUsertypes
    },
    nextPage () {
      return this.$store.getters.usersNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    currentPage () {
      return this.$store.getters.usersCurrentPage
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isAppIncluding () {
      return this.$store.getters.isAppIncluding
    },
    isAppNotIncluded () {
      return this.$store.getters.isAppNotIncluded
    },
    isBrowsIncluding () {
      return this.$store.getters.isBrowsIncluding
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (readMore) {
      if (this.shopIds.length !== 0) {
        window.sessionStorage.setItem('shopIds', this.shopIds)
      } else {
        window.sessionStorage.setItem('shopNull', 'on')
        window.sessionStorage.removeItem('shopIds')
      }
      if (this.userName !== null) {
        window.sessionStorage.setItem('userName', this.userName)
      } else {
        window.sessionStorage.removeItem('userName')
      }
      if (this.usertypeIds !== '') {
        window.sessionStorage.setItem('userTypeIds', this.usertypeIds)
      }

      // ソート保存
      this.saveSortState()

      var url = null
      if (readMore) {
        url = this.$store.getters.usersNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function (totalCount) {
        self.searchTotalCount = totalCount
        if (self.isAppNotIncluded || self.isBrowsIncluding) {
          self.shopDisabledFlag = true
        }
        self.searchCallbackFlag = true
      }
      var data = {
        'shop_ids': this.shopIds,
        'user_name': this.userName,
        'user_type_ids': this.usertypeIds,
        'order': this.orderByString()
      }
    if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }
      this.$store.dispatch('USERRETIREE_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order
      // 検索
      this.search('sort')
    },
    shopGet: function() {
      var self = this
      var callback = function (){
        self.shopGetCallbackFlag = true
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    usertypeGet: function() {
      var self = this
      var callback = function (){
        self.usertypeGetCallbackFlag = true
      }
      this.$store.dispatch('USERTYPE_ALL_GET', {callback: callback})
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          result.push(key + ' ' + asc_desc)
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('login_id asc')
      }
      return result.join(' , ')
    },
    goShopLists: function () {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    goPhotoLists: function () {
      utils.backClear()
      this.$router.push({ path: '/userphotos', query: { type: this.$router.currentRoute.query.type}})
    },
    goUserLists: function () {
      utils.backClear()
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goChangeLists: function () {
      utils.backClear()
      this.$router.push({ path: '/userchanges', query: { type: this.$router.currentRoute.query.type}})
    },
    goUserDetail: function (userId) {
      window.sessionStorage.setItem('retiree', 'on')
      this.$router.push({ path: '/users/' + userId })
    },
    half: function () {
      this.userName = utils.emHalf(this.userName)
    },
    /** 画像押下 */
    onClickImageModalShow: function (user) {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = user.attributes['avartar-path'] + '?token=' + this.authToken + "&timestamp=" + self.timeStamp

      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },
    /** ソート設定 */
    loadSortState: function() {
      var ssSortStateJSON = window.sessionStorage.getItem("sortState")
      if (!ssSortStateJSON) {
        return
      }
      var state = false
      var ssSortState = JSON.parse(ssSortStateJSON)
      if (!ssSortState['over_date']) {
        this.sortState['over_date'] = {'state': false, 'order': false}
      }
      for (var key in ssSortState) {
        if (this.sortState[key]) {
          this.sortState[key] = ssSortState[key]
          state |= ssSortState[key].state
        }
      }
      if (!state) {
        this.sortState['over_date'] = {'state': true, 'order': false}
      }
    },
    /** ソート保存 */
    saveSortState: function() {
      var ssSortState = JSON.parse(JSON.stringify(this.sortState))
      var ssSortStateJSON = window.sessionStorage.getItem("sortState")
      if (ssSortStateJSON) {
        ssSortState = JSON.parse(ssSortStateJSON)
        for (var key in ssSortState) {
          ssSortState[key] = {'state': false, 'order': false}
        }
        for (var key in this.sortState) {
          if (this.sortState[key]) {
            ssSortState[key] = this.sortState[key]
          }
        }
      }
      window.sessionStorage.setItem('sortState', JSON.stringify(ssSortState))
    },
    csvDownload: function() {
      var self = this
      var data = {
        'user_id': '',
        'retiree': true,
        'shop_ids': this.shopIds,
        'user_name': this.userName,
        'user_type_ids': this.usertypeIds
      }
      var callback = function() {
        self.csvFileName = 'userList.csv'

        var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        var mimeType = 'text/csv'
        var csv = '社員番号,社員ID,氏名,ふりがな,性別,生年月日,年齢,所属店舗,役職,入社日,入社経緯,郵便番号,住所,携帯番号,電話番号,メールアドレス,備考,役職異動後１,役職異動後日付１,役職異動後２,役職異動後日付２,役職異動後３,役職異動後日付３,店舗異動後１,店舗異動後日付１,店舗異動後２,店舗異動後日付２,店舗異動後３,店舗異動後日付３,運転免許証の登録の有無,任意保険証の登録の有無,車検証の登録の有無,身元保証書・保証人住民票・印鑑登録証明書・保証人確認票の登録の有無,誓約書の登録の有無,住民票の登録の有無,緊急連絡先・履歴書の登録の有無,制服貸与同意書の登録の有無,指導履歴の有無,面談履歴の有無,運転免許証期限日,任意保険証期限日,車検証期限日,身元保証書・保証人住民票・印鑑登録証明書・保証人確認票期限日,離職日,離職区分,離職事由,離職事由補記\n'
        self.csvData.forEach(function (obj) {
          if (obj.attributes['code']) {
            csv += obj.attributes['code'] + ","
          } else {
            csv += obj.id + ","
          }
          csv += obj.id + ","
          if (obj.attributes['user-name']) {
            csv += self.enquoteForCSV(obj.attributes['user-name']) + '　' + self.enquoteForCSV(obj.attributes['user-firstname']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-name-furigana'] && obj.attributes['user-firstname-furigana']) {
            csv += self.enquoteForCSV(obj.attributes['user-name-furigana']) + '　' + self.enquoteForCSV(obj.attributes['user-firstname-furigana']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['sex']) {
            csv += self.enquoteForCSV(obj.attributes['sex']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-birthday']) {
            csv += self.enquoteForCSV(obj.attributes['user-birthday']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['age']) {
            csv += self.enquoteForCSV(obj.attributes['age']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['shop-name']) {
            csv += self.enquoteForCSV(obj.attributes['shop-name']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-type-name']) {
            csv += self.enquoteForCSV(obj.attributes['user-type-name']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-joinday']) {
            csv += self.enquoteForCSV(obj.attributes['user-joinday']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['join-class']) {
            csv += self.enquoteForCSV(obj.attributes['join-class']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-post-no']) {
            csv += self.enquoteForCSV(obj.attributes['user-post-no']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-address']) {
            csv += self.enquoteForCSV(obj.attributes['user-address']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-mobile']) {
            csv += self.enquoteForCSV(obj.attributes['user-mobile']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-tel']) {
            csv += self.enquoteForCSV(obj.attributes['user-tel']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['email']) {
            csv += self.enquoteForCSV(obj.attributes['email']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-business-type-remarks']) {
            csv += self.enquoteForCSV(obj.attributes['user-business-type-remarks']) + ","
          } else {
            csv += ","
          }
          //役職履歴の検索直近の３件
          var user_type_change_day_1 = ''
          var user_type_name_after_1 = ''
          var user_type_change_day_2 = ''
          var user_type_name_after_2 = ''
          var user_type_change_day_3 = ''
          var user_type_name_after_3 = ''

          for(var i=0; i < self.csvUsertypesData.length; i++){

            if (obj.id == self.csvUsertypesData[i].attributes['user-id']) {
              if (user_type_change_day_1 == '') {
                user_type_change_day_1 = self.csvUsertypesData[i].attributes['change-day']
                user_type_name_after_1 = self.csvUsertypesData[i].attributes['user-type-name-after']
              } else if (user_type_change_day_2 == '') {
                user_type_change_day_2 = self.csvUsertypesData[i].attributes['change-day']
                user_type_name_after_2 = self.csvUsertypesData[i].attributes['user-type-name-after']
              } else if (user_type_change_day_3 == '') {
                user_type_change_day_3 = self.csvUsertypesData[i].attributes['change-day']
                user_type_name_after_3 = self.csvUsertypesData[i].attributes['user-type-name-after']
              }
            }
          }
          if (user_type_name_after_1) {
            csv += self.enquoteForCSV(user_type_name_after_1) + ","
          } else {
            csv += ","
          }
          if (user_type_change_day_1) {
            csv += self.enquoteForCSV(user_type_change_day_1) + ","
          } else {
            csv += ","
          }
          if (user_type_name_after_2) {
            csv += self.enquoteForCSV(user_type_name_after_2) + ","
          } else {
            csv += ","
          }
          if (user_type_change_day_2) {
            csv += self.enquoteForCSV(user_type_change_day_2) + ","
          } else {
            csv += ","
          }
          if (user_type_name_after_3) {
            csv += self.enquoteForCSV(user_type_name_after_3) + ","
          } else {
            csv += ","
          }
          if (user_type_change_day_3) {
            csv += self.enquoteForCSV(user_type_change_day_3) + ","
          } else {
            csv += ","
          }

          //店舗履歴の検索直近の３件
          var shop_change_day_1 = ''
          var shop_name_after_1 = ''
          var shop_change_day_2 = ''
          var shop_name_after_2 = ''
          var shop_change_day_3 = ''
          var shop_name_after_3 = ''

          for(var i=0; i < self.csvShopsData.length; i++){

            if (obj.id == self.csvShopsData[i].attributes['user-id']) {
              if (shop_change_day_1 == '') {
                shop_change_day_1 = self.csvShopsData[i].attributes['change-day']
                shop_name_after_1 = self.csvShopsData[i].attributes['shop-name-after']
              } else if (shop_change_day_2 == '') {
                shop_change_day_2 = self.csvShopsData[i].attributes['change-day']
                shop_name_after_2 = self.csvShopsData[i].attributes['shop-name-after']
              } else if (shop_change_day_3 == '') {
                shop_change_day_3 = self.csvShopsData[i].attributes['change-day']
                shop_name_after_3 = self.csvShopsData[i].attributes['shop-name-after']
              }
            }
          }
          if (shop_name_after_1) {
            csv += self.enquoteForCSV(shop_name_after_1) + ","
          } else {
            csv += ","
          }
          if (shop_change_day_1) {
            csv += self.enquoteForCSV(shop_change_day_1) + ","
          } else {
            csv += ","
          }
          if (shop_name_after_2) {
            csv += self.enquoteForCSV(shop_name_after_2) + ","
          } else {
            csv += ","
          }
          if (shop_change_day_2) {
            csv += self.enquoteForCSV(shop_change_day_2) + ","
          } else {
            csv += ","
          }
          if (shop_name_after_3) {
            csv += self.enquoteForCSV(shop_name_after_3) + ","
          } else {
            csv += ","
          }
          if (shop_change_day_3) {
            csv += self.enquoteForCSV(shop_change_day_3) + ","
          } else {
            csv += ","
          }
          csv += obj.attributes['license-file-exist'] + ","
          csv += obj.attributes['insurance-file-exist'] + ","
          csv += obj.attributes['car-file-exist'] + ","
          csv += obj.attributes['background-file-exist'] + ","
          csv += obj.attributes['signature-file-exist'] + ","
          csv += obj.attributes['residence-file-exist'] + ","
          csv += obj.attributes['emergency-file-exist'] + ","
          csv += obj.attributes['uniform-file-exist'] + ","
          csv += obj.attributes['guidance-file-exist'] + ","
          csv += obj.attributes['interview-file-exist'] + ","
          if (obj.attributes['user-license-file-date']) {
            csv += obj.attributes['user-license-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-insurance-file-date']) {
            csv += obj.attributes['user-insurance-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-car-file-date']) {
            csv += obj.attributes['user-car-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-background-file-date']) {
            csv += obj.attributes['user-background-file-date'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-overday']) {
            csv += obj.attributes['user-overday'].replace( /,/g, '') + ","
          } else {
            csv += ","
          }
          if (obj.attributes['turnover-class']) {
            csv += self.enquoteForCSV(obj.attributes['turnover-class']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['turnover-content']) {
            csv += self.enquoteForCSV(obj.attributes['turnover-content']) + ","
          } else {
            csv += ","
          }
          if (obj.attributes['user-turnover-type-remarks']) {
            csv += self.enquoteForCSV(obj.attributes['user-turnover-type-remarks'])
          }
          csv += "\n"

        })
        var blob = new Blob([bom, csv], { type: mimeType })
        var hiddenElement = document.createElement('a')
        hiddenElement.download = self.csvFileName
        hiddenElement.target = '_blank'
        if(window.navigator.msSaveBlob) {
          window.navigator.msSaveBlob(blob, self.csvFileName)
        } else if (window.URL && window.URL.createObjectURL){
          hiddenElement.href = window.URL.createObjectURL(blob)
          document.body.appendChild(hiddenElement)
          hiddenElement.click()
          document.body.removeChild(hiddenElement)
        } else if (window.webkitURL && window.webkitURL.createObject) {
          hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
          hiddenElement.click()
        } else {
          window.open('data:' + mimeType + ';base64,' + window.Base64.encode(content), '_blank')
        }
      }
      this.$store.dispatch('USER_CSV_DOWNLOAD', { data: data, callback: callback })
    },
    enquoteForCSV: function(val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"';
      }
      return val
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/retiree-list.js